import { USFlag } from '@components/icons/language/USFlag';
import { DEFlag } from '@components/icons/language/DEFlag';
import React, { ReactElement } from 'react';
import { FRFlag } from '@components/icons/language/FRFlag';
import { ILFlag } from '@components/icons/language/ILFlag';

interface SiteSettingsAuthor {
  name: string;
  websiteUrl: string;
  address: string;
}

interface SiteSettingsLogo {
  url: string;
  alt: string;
  href: string;
  width: number;
  height: number;
}

interface SiteHeader {
  menu: Array<SiteHeaderMenuItem>;
  languageMenu: Array<SiteHeaderLangMenuItem>;
  pagesMenu: Array<SiteHeaderMenuItem>;
}

interface SiteHeaderMenuItem {
  id: number;
  path: string;
  label: string;
  subMenu: Array<SiteHeaderMenuItem> | undefined;
}

interface SiteHeaderLangMenuItem {
  id: string;
  name: string;
  value: string;
  icon: ReactElement;
}

interface SiteSettings {
  name: string;
  description: string;
  author: SiteSettingsAuthor;
  logo: SiteSettingsLogo;
  defaultLanguage: 'en' | 'de';
  currencyCode: 'EUR' | 'EUR';
  site_header: SiteHeader;
}

export const siteSettings: SiteSettings = {
  name: 'Danel Feinkost',
  description: '',
  author: {
    name: 'Danel Feinkost GmbH - Co.KG',
    websiteUrl: 'https://danel-feinkost.com',
    address: '',
  },
  logo: {
    url: 'public/assets/images/logo.png',
    alt: 'Danel Feinkost',
    href: '',
    width: 128,
    height: 30,
  },
  defaultLanguage: 'de',
  currencyCode: 'EUR',
  site_header: {
    menu: [
      {
        id: 1,
        path: '/',
        label: 'menu-home',
        subMenu: undefined,
      },
      {
        id: 2,
        path: '/about-us',
        label: 'menu-about-us',
        subMenu: undefined,
      },
      {
        id: 3,
        path: '/products/',
        label: 'menu-products',
        subMenu: undefined,
      },
      {
        id: 4,
        path: '/contact-us',
        label: 'menu-contact-us',
        subMenu: undefined,
      },
    ],
    languageMenu: [
      {
        id: 'de',
        name: 'Deutsch - DE',
        value: 'de',
        icon: <DEFlag />,
      },
      {
        id: 'en',
        name: 'English - EN',
        value: 'en',
        icon: <USFlag />,
      },
      {
        id: 'fr',
        name: 'French - FR',
        value: 'fr',
        icon: <FRFlag />,
      },
      // {
      //   id: 'he',
      //   name: 'עברית - HE',
      //   value: 'he',
      //   icon: <ILFlag />,
      // },
      // {
      //   id: 'es',
      //   name: 'Español - ES',
      //   value: 'es',
      //   icon: <ESFlag />,
      // },
    ],
    pagesMenu: [
      {
        id: 1,
        path: '/',
        label: 'menu-home',
        subMenu: undefined,
      },
      {
        id: 2,
        path: '/products',
        label: 'menu-products',
        subMenu: undefined,
      },
      {
        id: 3,
        path: '/about-us',
        label: 'menu-about-us',
        subMenu: undefined,
      },
      // {
      //     id: 3,
      //     path: '/contact-us',
      //     label: 'menu-contact-us',
      //     subMenu: undefined
      // },
      // {
      //     id: 4,
      //     path: '/faq',
      //     label: 'menu-faq',
      //     subMenu: undefined
      // },
    ],
  },
};
